<template>
  <div>
    <vs-table
		:data="docList"
		class="mt-4"
		noDataText="Pas de document."
    >
      <template slot="thead">
        <vs-th class="bgcolor white-txt" style="padding-left: 12px; width: 200px;">DATE</vs-th>
        <vs-th class="bgcolor white-txt"><div style="text-align: center; width: 100%;">UTILISATEUR</div></vs-th>
        <vs-th class="bgcolor white-txt" style="padding-left: 0 !important;">TYPE</vs-th>
        <vs-th class="bgcolor white-txt" style="padding-left: 0 !important;">NOM DU FICHIER</vs-th>
        <vs-th class="bgcolor white-txt"><div style="text-align: center; width: 100%;">LIEN</div></vs-th>
        <vs-th class="bgcolor white-txt" style="width: 50px;">ACTION</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(row, index) in data.slice(0, lastPage)">
          <vs-td><div style="padding-left: 11px;">{{ row.creation_date.substr(0, 10).split("-").reverse().join("/") }}</div></vs-td>
          <vs-td style="padding-left: 0 !important;">
            <vx-tooltip
              :text="row.firstname + ' ' + row.lastname"
              position="top"
              style="text-align: center;"
            >
              <vs-avatar
                style="border: 1px solid #08B0B9;"
                :text="row.firstname + ' ' + row.lastname"
                :src="getCollaboratorAvatar(row.user_id)"
              />
            </vx-tooltip>
          </vs-td>
          <vs-td :id="'type' + row.id" v-if="refresh != row.id">{{ row.type_name }}</vs-td>
          <vs-td :id="'name' + row.id" v-if="refresh != row.id">{{ row.filename }}</vs-td>
          <vs-td :id="'link' + row.id" v-if="refresh != row.id" style="padding: 0 !important;">
			<vx-tooltip :text="row.link" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
				<a :href="row.link" target="_blank">
					<vs-button
						size="large"
						color="primary"
						type="flat"
						icon-pack="feather"
						icon="icon-external-link"
						@click="() => {pass;}"
					></vs-button>
				</a>
			</vx-tooltip>
			</vs-td>
			<vs-td>
				<el-dropdown>
					<vs-button class="btn-drop" icon-pack="feather" icon="icon-more-vertical" size="large"></vs-button>
					<el-dropdown-menu class="dropdown-menu">
						<el-dropdown-item v-if="$acl.check('noextern') && !row.editmode" @click="row.editmode=true;$forceUpdate();updateDoc(row)"><vs-button icon-pack="feather" icon="icon-edit" class="dropdown-btn">Modifier</vs-button></el-dropdown-item>
						<el-dropdown-item v-if="$acl.check('admin') && $acl.check('noextern') && !row.editmode" @click="displayValidationPopup(row.id, row.filename)"><vs-button icon-pack="feather" icon="icon-trash-2" class="dropdown-btn" style="margin-top: 5px;">Supprimer</vs-button></el-dropdown-item>
						<el-dropdown-item v-if="$acl.check('noextern') && row.editmode" @click="saveDoc(row.id)"><vs-button icon-pack="feather" icon="icon-save" class="dropdown-btn">Enregistrer</vs-button></el-dropdown-item>
						<el-dropdown-item v-if="$acl.check('noextern') && row.editmode" @click="cancelEdit(row.id)"><vs-button icon-pack="feather" icon="icon-x-square" class="dropdown-btn" style="margin-top: 5px;">Annuler</vs-button></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="vx-row justify-center pt-4">
      <vs-spacer/>
      <vs-button color="primary" @click="addPage" v-if="lastPage < contract_documents.length" type="border" style="border-radius: 1px 6px 6px 6px; height: 32px;">Voir plus</vs-button>
      <vs-spacer/>
    </div>
  </div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import VueCookies from "vue-cookies";

export default {
	name: "ContractDocumentsTable",
	components: {
	},
	props: {
		contract_id: Number,
		contract_documents: Array,
		typeList: Array
	},
	mixins: [dbFieldConvertor, utilsMixin],
	computed: {
		activeUser(){
			return VueCookies.get("userInfo");
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},
	data() {
		return {
			apiUrl: store.state.backendApiUrl,
			fullname: "",
			lastPage: 5,
			docList: [],
			refresh: "refresh"
		};
	},
	created() {
		store.dispatch("getAllContractsDocumentsTypes");
		this.docList = this.$props.contract_documents;
		for(let i = 0; i < this.docList.length; i++){
			this.docList[i]["editmode"] = false;
		}
		/*
		 * this.getAllCollaborators()
		 * this.getAllCollaboratorsAvatar()
		 */
	},
	watch: {
		contract_documents: function(data){
			this.lastPage = 5;
			this.docList = data;
			for(let i = 0; i < this.docList.length; i++){
				this.docList[i]["editmode"] = false;
			}
		}
	},
	methods: {
		addPage(){
			this.lastPage += 5;
		},
		subPage(){
			this.lastPage -= 5;
		},
		getName(userId){
			let foundUser = this.allCollaborators.findIndex(row => row.id == userId);
			if(foundUser >= 0){
				return this.allCollaborators[foundUser].firstname.replace(/^\S/, s => s.toUpperCase()) + " " + this.allCollaborators[foundUser].lastname.toUpperCase();
			}
			else{
				return " ";
			}
		},
		getCollaboratorAvatar(userId){
			let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
			if(foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		updateDoc(doc){
			document.getElementById("name" + doc.id).innerHTML = `<input placeholder="Nom du document" id="docName${doc.id}" value="${doc.filename}"/>`;

			document.getElementById("type" + doc.id).innerHTML = `<select id="docType${doc.id}"></select>`;

			for(let i = 0; i < this.typeList.length; i++){
				document.getElementById("docType" + doc.id).options.add(new Option(this.typeList[i].type_name, this.typeList[i].id));
				if(this.typeList[i].type_name == doc.type_name) document.getElementById("docType"+ doc.id).options[i].selected = true;
			}

			document.getElementById("link" + doc.id).innerHTML = `<input placeholder="Link" id="docLink${doc.id}" value="${doc.link}"/>`;
		},
		cancelEdit(id){
			for(let item of this.docList){
				if(item.id == id) {
					this.refresh = id;
					this.$nextTick(() => {
						item.editmode = false;
						this.refresh = "refresh";
					});
					return;
				}
			}
		},
		saveDoc(docId){
			let regex = /^(?:ftp|http|https):\/\/(?:[\w\.\-\+]+:{0,1}[\w\.\-\+]*@)?(?:[a-z0-9\-\.]+)(?::[0-9]+)?(?:\/|\/(?:[\w#!:\.\?\+=&%@!\-\/\(\)]+)|\?(?:[\w#!:\.\?\+=&%@!\-\/\(\)]+))?$/;
			let errText = "";

			if(document.getElementById("docName" + docId).value == "") errText+= "Le nom du document ne peut être vide.\n";
			if(document.getElementById("docLink" + docId).value == "") errText+= "Le lien ne peut être vide.\n";
			if(!regex.test(document.getElementById("docLink" + docId).value) && document.getElementById("docLink" + docId).value !== "") errText+= "Le lien saisi n'est pas valide. (Préfixes: ftp/http/https)";

			if(errText !== ""){
				this.$vs.notify({
					title: "Erreur",
					text: errText,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning"
				});
			}
			else{
				this.$http.post(this.apiUrl + "contracts_documents/edit", {
					id: docId,
					filename: document.getElementById("docName" + docId).value,
					link: document.getElementById("docLink" + docId).value,
					contract_document_type_id: document.getElementById("docType" + docId).selectedIndex + 1,
					user_id: this.activeUser.id
				}).then(() => {
					for(let item of this.docList){
						if(item.id == docId) {
							this.refresh = docId;
							item.filename = document.getElementById("docName" + docId).value,
							item.link = document.getElementById("docLink" + docId).value,
							item.type_name = this.typeList[document.getElementById("docType" + docId).selectedIndex].type_name,
							item.user_id = this.activeUser.id;
							this.$nextTick(() => {
								item.editmode = false;
								this.refresh = "refresh";
							});
							return;
						}
					}
				});
			}
		},
		displayValidationPopup(docId, docName){
			this.$emit("open-confirmation", [docId, docName]);
		},
	}
};
</script>

<style scoped>
.btn-drop {
	display: inline;
	color: black;
	background-color: transparent !important;
	pointer-events: none;
}

.dropdown-btn {
	padding: 0 !important;
	background: transparent !important;
}

.dropdown-btn:hover {
	color: #08B0B9;
}

el-dropdown {
	width: 65px;
	height: 40px;
	display: flex;
	overflow: visible;
	flex-wrap: nowrap;
	white-space: nowrap;
	margin-top: -5px;
}

el-dropdown:hover .dropdown-menu {
	display: flex !important;
}

el-dropdown-menu {
	position: relative;
    display: none;
    flex-direction: column;
    background: #6E6B7B;
    color: white;
    padding: 10px;
    border-radius: 5px;
    top: 15px;
	right: 115px;
	margin-left: 5px;
	cursor: pointer;
	font-weight: 400;
	z-index: 999;
	height: fit-content;
}
</style>
